export const filterOption = (value, options) => (
    options.filter(
        optionToSelect => String(optionToSelect.value) === String(value),
    )
);
